// extracted by mini-css-extract-plugin
export var skipLink = "gz_yf";